import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectService } from '../redirect/redirect.service';
import { MissingCapabilityService } from './missing-capability.service';


@Component({
    selector: 'missing-capability',
    templateUrl: './missing-capability.component.html',
    styleUrls: ['./missing-capability.component.scss']
})
export class MissingCapabilityComponent implements OnInit {

    public modalOpen: boolean;

    constructor(
        private _missingCapabilityService: MissingCapabilityService,
        private _router: Router,
        private _redirectService: RedirectService

    ) { }

    ngOnInit() {
        this._missingCapabilityService.modal.subscribe((isOpen) => {
            console.log('i received to open modal ?', isOpen);
            this.modalOpen = isOpen as boolean;
        });
    }

    closeModal() {
        this._missingCapabilityService.close();
    }

    redirect() {
        let role = localStorage.getItem('userRole');
        this.closeModal();
        if (role === 'supervisor') {
            this._router.navigateByUrl('/dashboard');
        }else {
            this._router.navigateByUrl('/signin');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/missing-capability/missing-capability.component.ts